import { Grid, Box, Chip, Card, CardContent } from '@material-ui/core'
import Carousel from 'react-material-ui-carousel'
import CurrencyFormat from 'react-currency-format'
import Map from '../Map/Map'
//HELPERS
import { embedYoutubeVideo, capitalizeFirstLetter } from '../../utils/helpers'

//COMPONENTS
import BookerForm from '../BookerForm/BookerForm'
import { useState } from 'react'
import './styles.scss'
import { LazyLoadImage } from 'react-lazy-load-image-component'

const ExperienceInformationAgency = ({
  singleExperience,
  gallery,
  hotDeal,
}) => {
  const [descriptionState, setDescriptionState] = useState(false)
  let description = singleExperience.description
  let shortDescription
  if (description.length > 1200) {
    let divideString = Math.floor(description.length / 2)
    shortDescription = description.substring(0, divideString)
  }

  const handleDescription = (e) => {
    e.preventDefault()
    setDescriptionState(!descriptionState)
  }

  const handleCarousel = () => {
    const carouselArray = []

    carouselArray.push({
      type: 'video',
      title: singleExperience.name,
      link: singleExperience.linkVideo,
    })

    gallery.forEach((item) => carouselArray.push({ type: 'photo', link: item }))

    return carouselArray
  }

  const handleLocator = () => {
    if (singleExperience.locator) {
      return singleExperience.locator.formatted_address
        ? singleExperience.locator.formatted_address
        : singleExperience.locator
    }
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        {singleExperience.linkVideo ? (
          <Carousel>
            {handleCarousel().map((item, index) => {
              if (item.type === 'video') {
                return (
                  <iframe
                    title={`exp-${item.title}`}
                    width="100%"
                    height="300px"
                    src={`//www.youtube.com/embed/${embedYoutubeVideo(
                      item.link,
                    )}`}
                    key={index}
                  />
                )
              } else {
                return (
                  <div
                    style={{
                      backgroundImage: `url(${item.link})`,
                      width: '100%',
                      height: '300px',
                      backgroundPosition: 'center center',
                      backgroundSize: 'cover',
                      borderRadius: '15px',
                    }}
                    key={index}
                  ></div>
                )
              }
            })}
          </Carousel>
        ) : (
          <Carousel>
            {gallery.map((item, index) => {
              return (
                <LazyLoadImage
                  src={item}
                  className="imgCarousel"
                  key={index}
                  alt="img not found @heyandes"
                />
              )
            })}
          </Carousel>
        )}

        <div className="price">
          {singleExperience.type === 'PXQ' ||
          singleExperience.type === 'PXH' ? (
            <p>Desde</p>
          ) : null}
          <CurrencyFormat
            value={
              singleExperience && singleExperience.type === 'PXH'
                ? singleExperience.pricePerHour[0]?.price
                : singleExperience && singleExperience.type === 'PXQ'
                ? singleExperience.priceQuantity[0]?.price
                : singleExperience.valuePerPerson
            }
            displayType="text"
            thousandSeparator
            className="pricecard"
            prefix="$"
          />
          <span>{' por reserva'}</span>
        </div>
        <Grid container spacing={2}>
          <p>
            {!shortDescription
              ? capitalizeFirstLetter(description)
              : shortDescription.length > 0 && descriptionState === false
              ? capitalizeFirstLetter(shortDescription)
              : description &&
                description.length > 0 &&
                descriptionState === true
              ? capitalizeFirstLetter(description)
              : null}
          </p>
          <p className="btnDescription" onClick={handleDescription}>
            {!shortDescription
              ? ' '
              : descriptionState === false
              ? 'Ver más'
              : 'Ver menos'}
          </p>
        </Grid>
        {!!singleExperience.equipmentRequired ||
        !!singleExperience.previousExperience ? (
          <hr className="hr-style" />
        ) : (
          ''
        )}

        <Grid container spacing={2}>
          {!!singleExperience.included?.length > 0 ? (
            <Grid item xs={12} md={12}>
              <Box>
                <h4>Incluye</h4>
                {singleExperience.included.map((servicio) => {
                  return (
                    <Chip
                      className="chip"
                      color="primary"
                      size="small"
                      label={capitalizeFirstLetter(servicio)}
                      key={servicio}
                    />
                  )
                })}
              </Box>
            </Grid>
          ) : (
            ''
          )}

          {!!singleExperience.equipmentRequired?.length > 0 ? (
            <Grid item xs={12} md={12}>
              <Box>
                <h4>Equipamiento requerido</h4>
                {singleExperience.equipmentRequired.map((servicio) => {
                  return (
                    <Chip
                      className="chip"
                      color="primary"
                      size="small"
                      label={capitalizeFirstLetter(servicio)}
                      key={servicio}
                    />
                  )
                })}
              </Box>
            </Grid>
          ) : (
            ''
          )}
          {!!singleExperience.previousExperience?.length > 0 ? (
            <Grid item xs={12} md={12}>
              <Box>
                <h4>Experiencia requerida</h4>
                {singleExperience.previousExperience.map((servicio) => {
                  return (
                    <Chip
                      className="chip"
                      color="primary"
                      size="small"
                      label={capitalizeFirstLetter(servicio)}
                      key={servicio}
                      style={{ wordWrap: 'break-word' }}
                    />
                  )
                })}
              </Box>
            </Grid>
          ) : (
            ''
          )}
        </Grid>
      </Grid>
      <Grid item xs={12} md={6}>
        <BookerForm
          type={singleExperience.category}
          hotDeal={hotDeal}
          experience={singleExperience}
        />
      </Grid>

      {!!singleExperience.locator ? (
        <>
          <Grid item md={12} xs={12}>
            <hr className="hr-style" />
            <Card style={{ marginTop: '25px' }}>
              <CardContent>
                {handleLocator() && (
                  <p style={{ margin: '15px 0' }}>
                    <span style={{ fontWeight: 'bold' }}>Ubicacion: </span>{' '}
                    {handleLocator()}{' '}
                  </p>
                )}
                {!!singleExperience.locator ? (
                  <>
                    <Map experience={singleExperience} />
                  </>
                ) : (
                  ''
                )}
              </CardContent>
            </Card>
          </Grid>
        </>
      ) : (
        ''
      )}
    </Grid>
  )
}

export default ExperienceInformationAgency
